import React, { useEffect } from "react";
import FilterDropdown from "./FilterDropdown";
import useSearchFilter from "hooks/useSearchFilter";
import { useSearchParams } from "react-router-dom";
import { formatStringForUrl } from "utils/formatUrl";
import { sortByOptions } from "utils/constants";
import { findSortByOption } from "utils/searchFilter";

const SortByFilter = () => {
  const { sortBy, setSortBy, toggleFilterDropdown } = useSearchFilter();
  const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = (sort) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set("sortBy", formatStringForUrl(sort));
    setSearchParams(params);
  };

  const handleSortBySelect = (value, id) => {
    setSortBy(value);
    updateSearchParams(value.label);
    toggleFilterDropdown(id);
  };

  // Initialize sort value
  useEffect(() => {
    const initialSortByValue = searchParams.get("sortBy") || "";
    const sortedOption = findSortByOption(initialSortByValue);
    if (sortedOption) {
      setSortBy(sortedOption);
    }
  }, [searchParams]);

  return (
    <FilterDropdown
      selectedItem={sortBy.label}
      id="sortBy"
      dropdownStyle={{
        minWidth: 250,
        maxWidth: 280,
        maxHeight: 250,
        overflowY: "auto",
      }}
      buttonStyle={{
        border: "none",
      }}
    >
      {sortByOptions.map((sort) => (
        <div
          key={sort.value}
          className={`filter-dropdown-list ${
            sortBy.value === sort.value
              ? "text-[#1DA1F2] bg-primary bg-opacity-10"
              : "text-black bg-white"
          }`}
          onClick={() => handleSortBySelect(sort, "sortBy")}
        >
          {sort.label}
        </div>
      ))}
    </FilterDropdown>
  );
};

export default SortByFilter;
